import { action, observable } from "mobx";
import NestStore from "./NestStore";
import AudioRepository from "../repository/AudioRepository";
import Audio from "../models/Audio";

class AudioStore extends NestStore {
  /**
   * @property {Audio[]}
   */
  @observable audios = [];

  constructor() {
    super();
    this.order = "asc";
    this.audioRepository = new AudioRepository();
  }

  @action
  getAll(params = {}) {
    this.isLoading = true;

    const paramsRequest = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
      ...params,
    };

    return this.audioRepository
      .fetch(paramsRequest)
      .then(response => {
        this.audios = [];

        response.data.audios.forEach(audioData => {
          this.audios.push(new Audio(audioData));
        });

        this.isLoading = false;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export default AudioStore;
